import { useEffect, useRef } from "react";
import { useToast } from "@/components/ui/use-toast";
import type { CandidateStatus, ModelCurrencyOverview } from "@/services/adminModelCurrency";

/** One toast when a candidate moves from "being tested" to passed or failed. */
export function useEvalCompletionToasts(overview: ModelCurrencyOverview | null) {
  const { toast } = useToast();
  const previous = useRef<Map<string, CandidateStatus>>(new Map());

  useEffect(() => {
    if (!overview) return;
    const next = new Map<string, CandidateStatus>();
    for (const useCase of overview.useCases) {
      for (const c of useCase.candidates) {
        next.set(c.id, c.status);
        if (previous.current.get(c.id) !== "evaluating") continue;
        if (c.status === "passed") toast({ title: `${c.model} passed its test` });
        if (c.status === "failed") {
          toast({ title: `${c.model} did not pass: see why below`, variant: "destructive" });
        }
      }
    }
    previous.current = next;
  }, [overview, toast]);
}
